
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre
            initializeFunction(splideElem, section); 
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let scrollCounter = 0;

    splideElem.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        e.preventDefault();

        scrollCounter++;

        if (scrollCounter >= 12) {
            scrollCounter = 0;

            if (e.deltaX < 0) {
                splideInstance.go('<'); 
            } else if (e.deltaX > 0) {
                splideInstance.go('>'); 
            }
        }
    });
}

/*********************************************************************************************
 * Splide reassurance - Initialisation
 *
 */
function initializeSplideReassurance(splideElem) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : false,
        pagination  : false,
        perPage     : 1,
        snap        : true,
        autoWidth   : true,
        destroy     : true,
        gap         : 12,
        breakpoints : {
            990: {
                destroy    : false,
            }
        }
    }).mount();

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

/*********************************************************************************************
 * Active title
 *
 */
function initializeActiveFaq(titleSelector, containerSelector) {
    const titles = document.querySelectorAll(titleSelector);
    const containers = document.querySelectorAll(containerSelector);

    if (titles.length > 0 && containers.length > 0) {
        // Activer le premier élément et son container par défaut
        titles[0].classList.add("active");
        containers[0].classList.add("active");

        titles.forEach((title, index) => {
            title.addEventListener("click", function () {
                // Retirer la classe active de tous les titres
                titles.forEach(t => t.classList.remove("active"));
                // Retirer la classe active de tous les containers
                containers.forEach(c => c.classList.remove("active"));

                // Ajouter la classe active au titre et au container correspondant
                title.classList.add("active");
                containers[index].classList.add("active");
            });
        });
    }
}

// Exécute les fonctions après le chargement du DOM
document.addEventListener("DOMContentLoaded", () => {
	initializeSectionsWithSplide('data-section-page-faq-id', '.mm-faq-title-splide', initializeSplideReassurance);
    initializeActiveFaq('.mm-faq-title-splide .mm-faq-title', '.mm-faq-dropdown-container');
});

// // Exécute les fonctions au redimensionnement de la fenêtre
// document.addEventListener("DOMContentLoaded", () => {
// });
